(function(){
    angular
        .module('appback')
        .directive('ngMovimientos', movimientosHojas);
        movimientosHojas.$inject = ['HojaService','StockService','$timeout', 'Upload'];
        function movimientosHojas(HojaService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=movimientos.twig',
		        scope: {
                    hc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.movimientos = [];
                        scope.getMovimientos = function(){
                            HojaService.getMovimientosHojaFabricacion(scope.hc.idhojafabricacionactiva, function(dataMovimientos){
                                scope.movimientos = dataMovimientos.movimientos;
                                console.log("movim",scope.movimientos);
                            });
                        }
                        scope.getMovimientos();
			        });
		        }
          }
      }
})();